"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overlayStyles = void 0;

var customScroll_1 = require("./customScroll");

exports.overlayStyles = function (theme) {
  var colorBgPopup = theme.colorBgPopup,
      sizeArrowWidth = theme.sizeArrowWidth,
      sizeArrowHeight = theme.sizeArrowHeight;
  return {
    overlay: {
      cursor: 'default',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 100000
    },
    overlayArrow: {
      position: 'absolute',
      display: 'block',
      width: '0',
      height: '0',
      background: 'transparent',
      borderBottom: sizeArrowHeight + "px solid " + colorBgPopup.normal,
      borderLeft: sizeArrowWidth / 2 + "px solid transparent",
      borderRight: sizeArrowWidth / 2 + "px solid transparent"
    },
    overlayArrowTop: {
      transform: 'rotate(180deg) translate(50%, -100%)',
      bottom: 0,
      left: '50%'
    },
    overlayArrowTopLeft: {
      transform: 'rotate(180deg) translateY(-100%)',
      bottom: 0,
      left: 0
    },
    overlayArrowTopRight: {
      transform: 'rotate(180deg) translateY(-100%)',
      bottom: 0,
      right: 0
    },
    overlayArrowBottom: {
      transform: 'rotate(0deg) translate(-50%, -100%)',
      top: 0,
      left: '50%'
    },
    overlayArrowBottomLeft: {
      transform: 'rotate(0deg) translateY(-100%)',
      top: 0,
      left: 0
    },
    overlayArrowBottomRight: {
      transform: 'rotate(0deg) translateY(-100%)',
      top: 0,
      right: 0
    },
    overlayArrowLeft: {
      transform: 'translateX(100%) translateY(-50%)',
      border: 'none',
      borderTop: sizeArrowWidth / 2 + "px solid transparent",
      borderLeft: sizeArrowHeight + "px solid " + colorBgPopup.normal,
      borderBottom: sizeArrowWidth / 2 + "px solid transparent",
      top: '50%',
      right: 0
    },
    overlayArrowLeftTop: {
      transform: 'translateX(100%)',
      top: 0
    },
    overlayArrowRight: {
      transform: 'translateX(-100%) translateY(-50%)',
      border: 'none',
      borderTop: sizeArrowWidth / 2 + "px solid transparent",
      borderRight: sizeArrowHeight + "px solid " + colorBgPopup.normal,
      borderBottom: sizeArrowWidth / 2 + "px solid transparent",
      top: '50%',
      left: 0
    },
    overlayArrowRightTop: {
      transform: 'translateX(-100%)',
      top: 0
    },
    customScroll: customScroll_1.customScroll(theme).scroll
  };
};